/* ВНИМАНИЕ!!!!!!!
 * Копия данных валидаторов лежит в папке с сервером /apps/next-app/server/utils/ab-tests-utils.js
 * если будете что-то править надо изменить там тоже
 * */
export const validateObjectKeys = (
  testingObject: Object,
  keys: string[],
  errorMessage = "Validation Error"
): boolean | never => {
  keys.forEach(key => {
    if (!Object.prototype.hasOwnProperty.call(testingObject, key)) {
      throw new Error(`${errorMessage}. No required key - ${key}`);
    }
  });

  return true;
};

type TExpectedType = "array" | "number" | "object" | "string" | "undefined";
export const validateType = (
  value: any,
  expectedType: TExpectedType,
  errorMessage = "Validation Error"
): boolean | never => {
  if (
    !(expectedType === "object" && value === null) &&
    ((expectedType === "array" && Array.isArray(value)) ||
      typeof value === expectedType)
  ) {
    return true;
  }

  throw new Error(
    `${errorMessage} Wrong value type: expected ${expectedType} - received ${typeof value}`
  );
};
